export default __webpack_public_path__ + "static/media/notTakingResponses.8075ed4e.svg";